import actions from './actions'
import mutations from './mutations'
import state from './state'
import getters from './getters'

export const applicationCustomer = {
  namespaced: true,
  actions,
  mutations,
  state,
  getters
}
